var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-menu"},[_c('ul',_vm._l((_vm.MenuLists),function(item,idx){return _c('li',{key:idx},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722cb25e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Products/kurenotori/partials/MenuBlock.vue
// module id = null
// module chunks = 